import { PaymentMethod } from '@stripe/stripe-js';

import { axios } from 'shared';

export interface CreateSetupIntentResponse {
  clientSecret: string;
}

export function createSetupIntent(type?: 'services' | 'rent') {
  return axios.post<CreateSetupIntentResponse>('/v1/stripe/setup_intents', { type });
}

export function listPaymentMethods(tenancyId: number) {
  return axios.get<PaymentMethod[]>(`/v2/tenancies/${tenancyId}/payment_methods`);
}

export function getDefaultPaymentMethod(tenancyId: number, type: 'services' | 'rent') {
  return axios.get<PaymentMethod>(`/v2/tenancies/${tenancyId}/payment_methods?type=${type}`);
}

export function deletePaymentMethod({ id, tenancyId }: { id: string; tenancyId: number }) {
  return axios.delete<PaymentMethod[]>(`/v2/tenancies/${tenancyId}/payment_methods/${id}`);
}
